exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form[data-v-60d201d6]{width:480px}.el-select[data-v-60d201d6]{width:100%}", ""]);

// exports
